<template>
	<div class="course-detail" :class="{ frame: $store.getters.isPc }" onselectstart="return false;">
		<div style="position: sticky; top: 0;z-index: 999;">
			<!-- 封面图片 -->
			<img v-if="!currentVideoSrc" class="cover" :src="$store.getters.baseCourseImgUrl + coverImage" alt="" />
			<!-- 视频标签 -->
			<video-player v-else :src="currentVideoSrc" :prevTiem="prevTiem" @timeupdate="onPlayerTimeupdate" @ended="onPlayerEnded"></video-player>
			<!-- tab栏 -->
			<nav class="tabs">
				<div class="tabs-item link">目录</div>
				<!-- <div class="tabs-item link">简介</div> -->
			</nav>
		</div>
		<div>
			<!-- 章节列表 -->
			<div class="article" :class="{ 'article-auto': currentActive === item.id }" v-for="item in courseDetail" :key="item.id">
				<div class="chapter-item">
					<div class="chapter link" @click="changeArticle(item.id)">
						<span>{{ item.name }}</span>
						<div class="progress-view">
							<span>{{ item.scale }}%</span>
							<img src="@/assets/course/arrow-bottom.png" />
						</div>
					</div>
					<div class="section" :id="'section' + item.id" style="z-index: 99;">
						<div class="section-item" v-for="part in item.part" :key="part.id" @click="changeSection(part, item)">
							<div class="section-name">
								<img v-if="currentPart === part.id" src="@/assets/course/active.png" alt="" />
								<img v-else src="@/assets/course/play.png" alt="" />
								<span :class="{ play: currentPart === part.id }">{{ part.name }}</span>
							</div>
							<span v-if="part.performance" class="progress">{{ _formatDuraton(part.video_duration) }} | 已完成</span>
							<span v-else class="progress">{{ _formatDuraton(part.video_duration) }} | 已学{{ part.scale }}%</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import videoPlayer from './video.vue';
import { formatDuraton } from '@/utils/format.js';
import { Dialog } from 'vant';

export default {
	data() {
		return {
			currentChapter: '',
			coverImage: '',
			// tabs: 1,
			currentActive: null,
			currentPart: null, // 当前播放
			subject_id: null, // 课程id
			courseDetail: [], // 课程详情
			lastTime: 0,
			sectionHeight: 0,
			// 当前视频播放链接
			currentVideoSrc: '',
			// 上次观看位置
			prevTiem: 0
		};
	},
	components: { videoPlayer },
	beforeCreate() {
		if (!this.$store.getters.getToken) {
			this.$router.replace('/course/login');
		}
	},
	created() {
		this.subject_id = this.$route.query.id;
		this.getCourseList().then(() => {
			return this.getCourseDetail();
		});
	},
	methods: {
		// 切换章
		changeArticle(id) {
			var el = document.getElementById('section' + id);
			this.sectionHeight = el.offsetHeight;
			console.log(this.sectionHeight);
			this.currentActive = this.currentActive === id ? null : id;
		},
		// 切换节
		changeSection(part, chapter) {
			this.currentActive = chapter.id;
			this.currentChapter = chapter.id;
			this.currentPart = part.id;
			// 此视频已经看完
			if (part.time == part.video_duration) {
				Dialog.alert({
					title: '温馨提示',
					message: '此视频已经看完，是否重新再看一次？',
					confirmButtonText: '再看一次',
					cancelButtonText: '观看下一节',
					showCancelButton: true,
					confirmButtonColor: '#017575'
				})
					.then(() => {
						this.service2('Corder/reset', { chapter_id: chapter.id, part_id: part.id }).then(() => {
							this.currentVideoSrc = part.video_file;
							this.prevTiem = 0;
						});
					})
					.catch(() => {
						this.autoNext();
					});
			} else {
				this.currentVideoSrc = part.video_file;
				this.prevTiem = part.time;
			}
		},
		// 获取上次播放位置(章 + 节)
		getCourseList() {
			return this.service2('Corder/myCourse').then(res => {
				let index = res.data.findIndex(item => item.id === +this.subject_id);
				if (-1 !== index) {
					let location = res.data[index];
					this.currentActive = this.currentChapter = +location.chapter_id;
					this.currentPart = +location.part_id;
					this.coverImage = location.index_image;
				}
			});
		},
		// 获取课程详情
		getCourseDetail() {
			return this.service2('Corder/courseShow', { subject_id: this.subject_id }).then(res => {
				this.courseDetail = res.data;
				// 获取上次播放位置(时间 + 地址)
				let index = res.data.findIndex(chapter => chapter.id === this.currentChapter);
				if (-1 !== index) {
					let partIndex = res.data[index].part.findIndex(part => part.id === this.currentPart);
					if (-1 !== partIndex) {
						let data = res.data[index].part[partIndex];
						this.prevTiem = data.time;
						this.currentVideoSrc = data.video_file;
					}
				}
			});
		},
		// 当前播放位置发生变化时触发。
		onPlayerTimeupdate(player) {
			let data = {
				chapter_id: this.currentChapter,
				part_id: this.currentPart,
				time: parseInt(player.currentTime),
				subject_id: this.subject_id
			};
			let now = new Date().valueOf();
			if (this.lastTime == 0) {
				this.lastTime = now;
			} else {
				if (now - this.lastTime > 3000) {
					this.lastTime = now;
					this.service2('Corder/update_progress', data);
				}
			}
		},
		// 视频播完回调
		onPlayerEnded(player) {
			let data = {
				chapter_id: this.currentChapter,
				part_id: this.currentPart,
				time: player.currentTime
			};
			this.service2('Corder/update_progress', data);
			this.service2('Corder/courseShow', { subject_id: this.subject_id }).then(res => {
				this.courseDetail = res.data;
				this.autoNext();
			});
		},
		// 播放下一节内容
		autoNext() {
			let currentChapterIndex = this.courseDetail.findIndex(chapter => chapter.id == this.currentChapter);
			let currentPartIndex = this.courseDetail[currentChapterIndex].part.findIndex(part => part.id == this.currentPart);
			if (currentPartIndex + 1 < this.courseDetail[currentChapterIndex].part.length) {
				// 本章之内的下一节
				console.log('本章之内的下一节', currentPartIndex, this.courseDetail[currentChapterIndex].part.length);
				this.changeSection(this.courseDetail[currentChapterIndex].part[currentPartIndex + 1], this.courseDetail[currentChapterIndex]);
			} else {
				currentChapterIndex++;
				console.log(currentChapterIndex + 1, this.courseDetail.length);
				if (currentChapterIndex < this.courseDetail.length) {
					// 切换至下一章的第一节
					console.log('切换至下一章的第一节');
					this.changeSection(this.courseDetail[currentChapterIndex].part[0], this.courseDetail[currentChapterIndex]);
				} else {
					// 全部都播放完了
					console.log('全部都播放完了');
				}
			}
		},
		// 视频时长格式化
		_formatDuraton(time) {
			return formatDuraton(time);
		}
	}
};
</script>
<style lang="less" scoped>
.course-detail {
	background-color: #f2f2f2;
	overflow: overlay;
	// tabs 栏
	.cover {
		width: 100%;
		height: 5.6rem;
		padding: 0;
		margin: 0;
		display: block;
	}
	.tabs {
		width: 100%;
		height: 1.067rem;
		background-color: #fff;
		display: flex;
		font-size: 0.427rem;
		align-items: center;
		.tabs-item {
			padding-left: 0.533rem;
			box-sizing: border-box;
		}
	}
	// 章节列表
	.article-auto {
		height: auto !important;
	}
	.article {
		padding: 0.267rem;
		background: #ffffff;
		margin: 0.267rem;
		padding: 0 0.4rem;
		box-shadow: 0px 0px 0.213rem 0px rgba(223, 223, 223, 1);
		border-radius: 0.213rem;
		font-size: 0.373rem;
		color: #666;
		height: 1.067rem;
		box-sizing: border-box;
		overflow: hidden;
		z-index: 998;
		.chapter {
			height: 1.067rem;
			display: flex;
			justify-content: space-between;
			align-items: center;
			box-sizing: border-box;
			.progress-view {
				display: flex;
				align-items: center;
				img {
					box-sizing: border-box;
					width: 0.427rem;
					height: 0.267rem;
					// transition: all 0.3s;
					margin-left: 0.133rem;
					// transform: rotateX(180deg);
					// z-index: 1;
				}
				.arrow {
					transform: rotateX(0deg);
				}
			}
		}
		.section {
			overflow: hidden;
			transition: height 0.3s;
			.section-item {
				min-height: 40px;
				padding: 0.267rem 0;

				.section-name {
					display: flex;
					align-items: center;
					margin-bottom: 0.133rem;
					img {
						width: 0.427rem;
						height: 0.427rem;
						margin-right: 0.267rem;
					}
					.play {
						color: #017575 !important;
					}
					span {
						font-size: 0.373rem;
						color: #666;
					}
				}
				.progress {
					color: #999;
					font-size: 0.32rem;
					margin-left: 0.693rem;
				}
			}
		}
	}
}
</style>
